import React, {Component} from 'react';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';

import MobileRow from './Row/MobileRow';
import Row from './Row/Row';
import './RequestTable.css';

export default class RequestTable extends Component {
  state = {
    rows: []
  };

  constructor(props) {
    super(props);

    this.dataRef = this.props.firebase.database().ref('applications');

    this.dataRef.on('value', snapshot => {
      let toAdd = snapshot.val();
      if (Array.isArray(toAdd)) {
        // firebase will treat the snapshot as an array if its keys are like 1, 2, 3 etc
        // we need to filter blank values
        toAdd = toAdd.filter(r => r);
      }
      this.setState({
        rows: toAdd
      });
    });
  }

  componentWillUnmount() {
    this.dataRef.off();
  }

  render() {
    // filter out any requests that do not have a datetime app, this stops late coming redirects
    // showing on the board
    const filteredRows = filter(this.state.rows, r => !!r.DATETIME_APP);

    const dateOrdered = sortBy(filteredRows, ['DATETIME_APP']).reverse();

    let rows = dateOrdered.map(r =>
    {
      return <div>
        <div className="mobile">
          <MobileRow row={r} key={r.CUSTOMER_ID} logosById={this.props.logosById}/>
        </div>
        <div className="desktop">
          <Row row={r} key={r.CUSTOMER_ID} logosById={this.props.logosById}/>
        </div>
      </div>;
    });

    return (
      <div className="requestTable">
        {rows}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/RequestTable/RequestTable.js